<style>
@font-face {
  font-family: 'Noto Color Emoji';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/notocoloremoji/v32/Yq6P-KqIXTD0t4D9z1ESnKM3-HpFabsE4tq3luCC7p-aXxcn.0.woff2) format('woff2');
  unicode-range: U+1f1e6-1f1ff;
}
.noto-color-emoji-regular {
  font-family: "Noto Color Emoji", sans-serif;
  color: #2d2d2d;
  font-weight: 400;
  font-style: normal;
}

</style>
<template>
    <v-app>
        <v-container fluid>
            <v-row v-if="$insertAccess($route.path)">
                <v-col cols="12">
                    <v-form @submit.prevent="submit" ref="addEmployee" id="addEmployee">
                         <div class="d-flex align-center mb-6">
                            <v-icon size="32" color="primary" class="me-2">mdi-clipboard-plus</v-icon>
                            <h2 class="text-h5 font-weight-bold text-primary">{{ isEntryMode ? "Add Lead" : "Update Lead" }} </h2>
                        </div>

                        <v-expansion-panels v-model="panel" class="mb-4" variant="accordion">
                            <v-expansion-panel>
                                <v-expansion-panel-text>
                                    <v-container fluid>
                                        <v-row>
                                            <v-col cols="12">
                                                <v-card class="mt-0 elevation-1 rounded-lg">
                                                    <v-card-text>
                                                        <v-row>
                                                            <v-col sm="4" md="3" cols="12" class="py-2">
                                                                <v-date-input
                                                                    input-format="dd/mm/yyyy"
                                                                    prepend-icon=""
                                                                    prepend-inner-icon="mdi-calendar"
                                                                    density="compact"
                                                                    variant="outlined"
                                                                    bg-color="white"
                                                                    v-model="lead_date.value.value"
                                                                    :error-messages="lead_date.errorMessage.value"
                                                                    autocomplete="off"
                                                                    clearable
                                                                >
                                                                    <template #label>
                                                                        Create Date
                                                                        <span class="text-red-accent-4">*</span>
                                                                    </template>
                                                                </v-date-input>
                                                            </v-col>
                                                             <v-col cols="12" sm="4" md="3" class="pa-0 py-2">
                                                                <v-autocomplete
                                                                    variant="outlined"
                                                                    density="compact"
                                                                    bg-color="white"
                                                                    v-model="lead_source_type_id.value.value"
                                                                    :items="getSalesLeadTypes"
                                                                    :item-title="(item) => `${item.name}`"
                                                                    item-value="id"
                                                                    :error-messages="lead_source_type_id.errorMessage.value"
                                                                    autocomplete="off"
                                                                    clearable
                                                                >
                                                                    <template #label>
                                                                        Source Type
                                                                        <span class="text-red-accent-4">*</span>
                                                                    </template>
                                                                </v-autocomplete>
                                                            </v-col>
                                                        </v-row>
                                                     </v-card-text>
                                                </v-card>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-card class="mt-0 elevation-1 rounded-lg">
                                                    <v-card-title class="d-flex align-center py-2 px-4 bg-blue-grey-lighten-5" style="font-size: 1.1rem;">
                                                        <v-icon color="primary" size="small" class="mr-2">mdi-domain</v-icon>
                                                        <span class="font-weight-medium text-primary">Company Information</span>

                                                    </v-card-title>

                                                    <v-divider></v-divider>
                                                    <v-card-text>
                                                        <v-row>  
                                                            <v-col cols="12" sm="6" md="6">
                                                                <v-row>
                                                                    <v-col cols="12" sm="6" md="6" class="px-2 pa-0 pt-1">
                                                                        <v-text-field
                                                                            density="compact"
                                                                            variant="outlined"
                                                                            bg-color="white"
                                                                            v-model="company_name.value.value"
                                                                            :error-messages="company_name.errorMessage.value"
                                                                            autocomplete="off"
                                                                            clearable
                                                                        >
                                                                            <template #label>
                                                                                Company Name
                                                                                <span class="text-red-accent-4">*</span>
                                                                            </template>
                                                                        </v-text-field>    
                                                                    </v-col>
                                                                    <v-col cols="12" sm="6" md="6" class="px-2 pa-0 pt-1">
                                                                        <v-text-field
                                                                            density="compact"
                                                                            variant="outlined"
                                                                            bg-color="white"
                                                                            v-model="company_email.value.value"
                                                                            :error-messages="company_email.errorMessage.value"
                                                                            autocomplete="off"
                                                                            clearable
                                                                        >
                                                                            <template #label>
                                                                                Company Email
                                                                                <span class="text-red-accent-4">*</span>
                                                                            </template>
                                                                        </v-text-field> 
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row>
                                                                    <v-col cols="12" sm="6" md="6" class="px-2 pa-0 pt-1">
                                                                        <v-autocomplete
                                                                            label="Company Country"
                                                                            variant="outlined"
                                                                            density="compact"
                                                                            bg-color="white"
                                                                            v-model="company_country_id.value.value"
                                                                            :items="getInvCountryList"
                                                                            item-title="name"
                                                                            item-value="id"
                                                                            :error-messages="company_country_id.errorMessage.value"
                                                                            autocomplete="off"
                                                                            :menu-props="{ width: 300 }"
                                                                            clearable
                                                                        >
                                                                            <template v-slot:selection="{ props, item }">
                                                                                <div class="d-flex align-center noto-color-emoji-regular"
                                                                                    v-bind="props"
                                                                                    color="primary"
                                                                                    variant="tonal"
                                                                                >
                                                                                <span class="mr-1">{{ item.raw.emoji }}</span>
                                                                                {{ item.raw.name }}
                                                                            </div>
                                                                            </template>

                                                                            <template v-slot:item="{ props, item }">
                                                                                <v-list-item v-bind="props" v-slot=""  :title="null">
                                                                                    <div class="d-flex align-center noto-color-emoji-regular" style="width: 100%;">
                                                                                        <span class="mr-2 text-lg">{{ item.raw.emoji }}</span>
                                                                                        <div class="flex-grow-1">
                                                                                            <span>{{ item.raw.name }}</span>
                                                                                            <small v-if="item.raw.native" class="text-grey">
                                                                                                ({{ item.raw.native }})
                                                                                            </small>
                                                                                        </div>
                                                                                        <div class="text-grey text-caption">
                                                                                            +{{ item.raw.phonecode }}
                                                                                        </div>
                                                                                    </div>
                                                                                </v-list-item>
                                                                            </template>
                                                                        </v-autocomplete>
                                                                    </v-col>
                                                                    <v-col cols="12" sm="6" md="6" class="px-2 pa-0 pt-1">
                                                                        <v-text-field
                                                                            label="Company Mobile no."
                                                                            density="compact"
                                                                            variant="outlined"
                                                                            bg-color="white"
                                                                            v-model="company_phone.value.value"
                                                                            :error-messages="company_phone.errorMessage.value"
                                                                            autocomplete="off"
                                                                            clearable
                                                                        >
                                                                        </v-text-field>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row>
                                                                    <v-col cols="12" sm="6" md="6" class="px-2 pa-0 pt-1">
                                                                        <v-text-field
                                                                            label="Company Website"
                                                                            density="compact"
                                                                            variant="outlined"
                                                                            bg-color="white"
                                                                            v-model="company_website.value.value"
                                                                            :error-messages="company_website.errorMessage.value"
                                                                            autocomplete="off"
                                                                            clearable
                                                                        >
                                                                        </v-text-field>  
                                                                    </v-col>
                                                                    <v-col cols="12" sm="6" md="6" class="px-2 pa-0 pt-1">
                                                                        <v-text-field
                                                                            label="Company Nature of Business"
                                                                            density="compact"
                                                                            variant="outlined"
                                                                            bg-color="white"
                                                                            v-model="company_nature_of_business.value.value"
                                                                            :error-messages="company_nature_of_business.errorMessage.value"
                                                                            autocomplete="off"
                                                                            clearable
                                                                        >
                                                                        </v-text-field>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>

                                                            <v-col cols="12" sm="6" md="6">
                                                                <v-row>
                                                                    <v-col cols="12" sm="6" md="6" class="px-2 pa-0 pt-1">
                                                                        <v-text-field
                                                                        label="Requirement Type"
                                                                        variant="outlined"
                                                                        density="compact"
                                                                        bg-color="white"
                                                                        v-model="requirement_type.value.value"
                                                                        :error-messages="requirement_type.errorMessage.value"
                                                                        autocomplete="off"
                                                                        clearable
                                                                        >
                                                                        </v-text-field>
                                                                    </v-col>
                                                                </v-row>
                                                                 <v-row>
                                                                    <v-col cols="12" sm="6" md="6" class="px-2 pa-0 pt-1">
                                                                         <v-textarea
                                                                            density="compact"
                                                                            variant="outlined"
                                                                            bg-color="white"
                                                                            v-model="company_address.value.value"
                                                                            :error-messages="company_address.errorMessage.value"
                                                                            autocomplete="off"
                                                                            rows="4"
                                                                            clearable
                                                                        >
                                                                            <template #label>
                                                                                Company Address
                                                                                <span class="text-red-accent-4">*</span>
                                                                            </template>
                                                                        </v-textarea>
                                                                    </v-col>
                                                                    <v-col cols="12" sm="6" md="6" class="px-2 pa-0 pt-1">
                                                                        <v-textarea
                                                                            label="Requirement Details"
                                                                            rows="4"
                                                                            variant="outlined"
                                                                            density="compact"
                                                                            bg-color="white"
                                                                            v-model="requirement_details.value.value"
                                                                            :error-messages="requirement_details.errorMessage.value"
                                                                            autocomplete="off"
                                                                            clearable
                                                                        >
                                                                        </v-textarea>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row>
                                                                    
                                                                </v-row>
                                                            </v-col>
                                                        </v-row>  
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>

                                            <!-- Customer -->
                                            <v-col cols="12">
                                                <v-card class="mt-0 elevation-1 rounded-lg">
                                                    <v-card-title class="d-flex align-center py-2 px-4 bg-blue-grey-lighten-5" style="font-size: 1.1rem;">
                                                        <v-icon color="primary" size="small" class="mr-2">mdi-account</v-icon>
                                                        <span class="font-weight-medium text-primary">Customer Information</span>

                                                    </v-card-title>

                                                    <v-divider></v-divider>
                                                    <v-card-text>
                                                       <v-row>
                                                            <v-col cols="12" sm="4" md="3" class="px-2 pa-0 pt-1">
                                                                <v-text-field
                                                                    density="compact"
                                                                    variant="outlined"
                                                                    bg-color="white"
                                                                    v-model="contact_name.value.value"
                                                                    :error-messages="contact_name.errorMessage.value"
                                                                    autocomplete="off"
                                                                    clearable
                                                                >
                                                                    <template #label>
                                                                        Contact Person Name
                                                                        <span class="text-red-accent-4">*</span>
                                                                    </template>
                                                                </v-text-field>
                                                            </v-col>
                            
                                                            <v-col cols="12" sm="4" md="3" class="px-2 pa-0 pt-1">
                                                                <v-text-field
                                                                    density="compact"
                                                                    variant="outlined"
                                                                    bg-color="white"
                                                                    v-model="contact_email.value.value"
                                                                    :error-messages="contact_email.errorMessage.value"
                                                                    autocomplete="off"
                                                                    clearable
                                                                >
                                                                    <template #label>
                                                                        Contact person Email
                                                                        <span class="text-red-accent-4">*</span>
                                                                    </template>
                                                                </v-text-field> 
                                                            </v-col>
                            
                                                            <v-col cols="12" sm="4" md="3" class="px-2 pa-0 pt-1">
                                                                <v-text-field
                                                                    density="compact"
                                                                    variant="outlined"
                                                                    bg-color="white"
                                                                    v-model="contact_number.value.value"
                                                                    :error-messages="contact_number.errorMessage.value"
                                                                    autocomplete="off"
                                                                    clearable
                                                                >
                                                                    <template #label>
                                                                        Contact person Mobile No
                                                                        <span class="text-red-accent-4">*</span>
                                                                    </template>
                                                                </v-text-field>
                                                            </v-col>
                            
                                                            <v-col cols="12" sm="4" md="3" class="px-2 pa-0 pt-1">
                                                                <v-text-field
                                                                    density="compact"
                                                                    variant="outlined"
                                                                    bg-color="white"
                                                                    v-model="contact_designation.value.value"
                                                                    :error-messages="contact_designation.errorMessage.value"
                                                                    autocomplete="off"
                                                                    clearable
                                                                >
                                                                    <template #label>
                                                                        Contact person Designation
                                                                        <span class="text-red-accent-4">*</span>
                                                                    </template>
                                                                </v-text-field>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>

                                              <!-- Lead detail -->
                                            <v-col cols="12">
                                                <v-card class="mt-0 elevation-1 rounded-lg">
                                                    <v-card-title class="d-flex align-center py-2 px-4 bg-blue-grey-lighten-5" style="font-size: 1.1rem;">
                                                        <v-icon color="primary" size="small" class="mr-2">mdi-clipboard-text</v-icon>
                                                        <span class="font-weight-medium text-primary">Lead Details</span>

                                                    </v-card-title>

                                                    <v-divider></v-divider>
                                                    <v-card-text>
                                                        <v-row>
                                                            <v-col cols="12" sm="4" md="4" class="px-2 pa-0 pt-1">
                                                                <v-text-field
                                                                    label="Lead Value"
                                                                    variant="outlined"
                                                                    density="compact"
                                                                    bg-color="white"
                                                                    v-model="lead_value.value.value"
                                                                    :disabled="!isEntryMode"
                                                                    :error-messages="lead_value.errorMessage.value"
                                                                    autocomplete="off"
                                                                    clearable
                                                                >
                                                                </v-text-field>
                                                                 <v-date-input
                                                                    input-format="dd/mm/yyyy"
                                                                    prepend-icon=""
                                                                    prepend-inner-icon="mdi-calendar"
                                                                    label="Follow up date"
                                                                    density="compact"
                                                                    variant="outlined"
                                                                    bg-color="white"
                                                                    v-model="follow_up_date.value.value"
                                                                    :disabled="!isEntryMode"
                                                                    :error-messages="follow_up_date.errorMessage.value"
                                                                    autocomplete="off"
                                                                    clearable
                                                                >
                                                                </v-date-input>
                                                                <v-date-input
                                                                    input-format="dd/mm/yyyy"
                                                                    prepend-icon=""
                                                                    prepend-inner-icon="mdi-calendar"
                                                                    label="Next Follow up date"
                                                                    density="compact"
                                                                    variant="outlined"
                                                                    bg-color="white"
                                                                    v-model="next_follow_up_date.value.value"
                                                                    :disabled="!isEntryMode"
                                                                    :error-messages="next_follow_up_date.errorMessage.value"
                                                                    autocomplete="off"
                                                                    clearable
                                                                ></v-date-input>

                                                                <v-autocomplete
                                                                    label="Lead Status"
                                                                    variant="outlined"
                                                                    density="compact"
                                                                    bg-color="white"
                                                                    v-model="lead_status_id.value.value"
                                                                    :items="getSalesLeadStatus"
                                                                    :item-title="(item) => `${item.name}`"
                                                                    item-value="id"
                                                                    :disabled="!isEntryMode"
                                                                    :error-messages="lead_status_id.errorMessage.value"
                                                                    autocomplete="off"
                                                                    clearable
                                                                >
                                                                </v-autocomplete>                            
                                                            </v-col>
                            
                                                            <v-col cols="12" sm="8" md="8" class="px-2 pa-0 pt-1">
                                                               <v-textarea
                                                                    label="Synopsis Details"
                                                                    variant="outlined"
                                                                    density="compact"
                                                                    bg-color="white"
                                                                    rows="8"
                                                                    v-model="synopsis_details.value.value"
                                                                    :disabled="!isEntryMode"
                                                                    :error-messages="synopsis_details.errorMessage.value"
                                                                    autocomplete="off"
                                                                    clearable
                                                                ></v-textarea>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-expansion-panel-text>
                            </v-expansion-panel>
                        </v-expansion-panels>
                       
                        <v-row class="d-flex justify-end px-5 mt-2">
                            <v-checkbox
                                :true-value="1"
                                :false-value="0"
                                v-model="status.value.value"
                                label="Active"
                                color="primary"
                            ></v-checkbox>  
                        </v-row>
                        <input v-model="lead_id.value.value" type="hidden">

                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-layout class="justify-end">
                                <v-btn class="bg-red" variant="flat" type="reset">Reset</v-btn>
                                <v-btn 
                                    class="bg-brand w-15 ms-2"  
                                    variant="flat" 
                                    type="submit"   
                                    @click="submit"
                                >
                                    {{ buttonText }}
                                </v-btn>
                            </v-layout>
                        </v-card-actions>
                    </v-form>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>

import {useStore} from 'vuex';
import { useField, useForm } from 'vee-validate';
import * as yup from 'yup';
import { ref, watch } from 'vue';
import { toast } from 'vue3-toastify';
import formattedDate from '@/plugins/dateFormatter';
import { useRouter, useRoute } from 'vue-router';

export default {
    components: {
    },
    data: () => ({
        panel: [0],
        panel1: [0],
        panel2: [0],
        panel3: [0],
        loading:false,
        errorMessages:'',
        isEntryMode: true,
        visible: false,
        search: "",
        selectedImage: null,
        photo_imageFile:'',
        preview: '/src/assets/no_preview.png',
    }),
    watch: {
    },
    created(){
        if (this.$store.getters.getInvCountryList.length === 0) {
            this.$store.dispatch('getInvCountryList');
        }

        if(this.$store.getters.getHrmDesignationList.length === 0) {
            this.$store.dispatch('getHrmDesignationList');
        }

        if(this.$store.getters.getSalesLeads.length === 0) {
            this.$store.dispatch('getSalesLeads');
        }

        if(this.$store.getters.getSalesLeadTypes.length === 0) {
            this.$store.dispatch('getSalesLeadTypes');
        }
        if(this.$store.getters.getSalesLeadStatus.length === 0) {
            this.$store.dispatch('getSalesLeadStatus');
        }
    },
    computed:{
        getInvCountryList() {
            console.log(this.$store.getters.getInvCountryList)
            return this.$store.getters.getInvCountryList;
        },
        getHrmDesignationList() {
            return this.$store.getters.getHrmDesignationList;
        },
        getSalesLeads() {
            return this.$store.getters.getSalesLeads;
        },
        getSalesLeadTypes() {
            return this.$store.getters.getSalesLeadTypes;
        },
        getSalesLeadStatus() {
            return this.$store.getters.getSalesLeadStatus;
        },
    },
    methods: {
        editItem(item){
            this.buttonText = 'Update';
            this.status.value.value = item.status;
            this.lead_id.value.value = item.id;
        },
    },
    setup() {
        const { handleSubmit, resetForm} = useForm({
            validationSchema: yup.object({
                lead_date: yup.string().required().label('Create Date'),
                company_name: yup.string().min(3).max(70).required().trim().label('Company Name'),
                company_email: yup.string().email().max(50).required().trim().label('Company Email'),
                company_phone: yup.string().trim().min(7).max(15).nullable().label('Company Mobile No'),
                company_website: yup.string().min(3).max(70).nullable().trim().label('Company Website'),
                company_address: yup.string().min(3).max(250).required().trim().label('Company Address'),
                company_nature_of_business: yup.string().min(3).max(50).nullable().trim().label('Company Nature of Business'),
                contact_name: yup.string().min(3).max(50).required().trim().label('Contact Person Name'),
                contact_email: yup.string().min(3).max(50).required().trim().email().label('Contact Person Email'),
                contact_number: yup.string().trim().min(7).max(15).nullable().label('Contact Person Mobile No'),
                contact_designation: yup.string().required().label('Company Person Designation'),
                lead_source_type_id: yup.string().required().label('Lead Source Type'),
                lead_value: yup.string().nullable().min(3).max(50).label('Lead Value'),
                follow_up_date: yup.string().nullable().label('Follow up date'),
                next_follow_up_date: yup.string().nullable().label('Next Follow up date'),
                requirement_type: yup.string().nullable().label('Requirement Type'),
                status: yup.number().nullable().label('Active'),
                lead_status_id: yup.string().nullable().label('Lead Status'),
                requirement_details: yup.string().min(3).max(400).nullable().label('Requirement Details'),
                synopsis_details: yup.string().min(3).max(400).nullable().label('Synposis Details'),

            }),

        });

        const lead_date = useField('lead_date');
        const company_name = useField('company_name');
        const company_email = useField('company_email');
        const company_phone = useField('company_phone');
        const company_website = useField('company_website');
        const company_address = useField('company_address');
        const company_country_id = useField('company_country_id');
        const company_nature_of_business = useField('company_nature_of_business');
        const contact_name = useField('contact_name');
        const contact_email = useField('contact_email');
        const contact_number = useField('contact_number');
        const contact_designation = useField('contact_designation');
        const lead_source_type_id = useField('lead_source_type_id');
        const lead_value = useField('lead_value');
        const follow_up_date = useField('follow_up_date');
        const next_follow_up_date = useField('next_follow_up_date');
        const requirement_type = useField('requirement_type');
        // const lead_interest_id = useField('lead_interest_id');
        // const lead_action_id = useField('lead_action_id');
        const lead_status_id = useField('lead_status_id');
        const requirement_details = useField('requirement_details');
        const synopsis_details = useField('synopsis_details');
        const status = useField('status');
        const lead_id = useField('lead_id')
        const errorMessages = ref('');
        const loading  = ref('');
        const buttonText  = ref('');
        buttonText.value = 'Save';
        const store = useStore();
        const router = useRouter();
        const route = useRoute();
        const submit = handleSubmit((values) => {
            values.follow_up_date = formattedDate(follow_up_date.value.value);
            values.next_follow_up_date = formattedDate(next_follow_up_date.value.value);
            values.lead_date = formattedDate(lead_date.value.value);
            // Create a FormData object
            const formData = new FormData();
            // Append all form values to FormData
            Object.keys(values).forEach((key) => { formData.append(key, values[key] || "");});
            store.dispatch("saveUpdateSalesLeads", formData, { headers: { 'Content-Type': 'multipart/form-data' } })
                .then((response) => {
                    resetForm();
                    buttonText.value = 'Save';
                    toast.success(response.data.message, {
                        timeout: 3000,
                    });
                    setTimeout(() => {
                        router.push({ path: "crm-lead-record" });
                    }, 2000);
                })
                .catch((error) => {            
                    toast.error(error.response.data.message);          
                })
        });
        
        return {
            submit,
            lead_date,
            company_name,
            company_email,
            company_phone,
            company_website,
            company_address,
            company_country_id,
            company_nature_of_business,
            contact_name,
            contact_email,
            contact_number,
            contact_designation,
            lead_source_type_id,
            lead_value,
            follow_up_date,
            next_follow_up_date,
            requirement_type,
            // lead_interest_id,
            status,
            resetForm,
            // lead_action_id,
            lead_status_id,
            lead_id,
            requirement_details,
            synopsis_details,
            errorMessages,
            buttonText,
            loading
        }
    },
    mounted() {
        const queryId = this.$route.query.id;
        if (this.$store.getters.getEditingSalesLeads && queryId) {
            const leads = this.$store.getters.getEditingSalesLeads;
            this.isEntryMode = false;
            this.lead_id.value.value = leads.id,
            this.lead_date.value.value = leads.lead_date,
            this.company_name.value.value = leads.company_name
            this.company_email.value.value = leads.company_email ,
            this.company_phone.value.value = leads.company_phone,
            this.company_website.value.value = leads.company_website,
            this.company_address.value.value = leads.company_address,
            this.company_country_id.value.value = leads.company_country_id,
            this.company_nature_of_business.value.value = leads.company_nature_of_business,
            this.contact_name.value.value = leads.contact_name,
            this.contact_email.value.value = leads.contact_email,
            this.contact_number.value.value = leads.contact_number,
            this.contact_designation.value.value = leads.contact_designation,
            this.lead_source_type_id.value.value = leads.lead_source_type_id,
            this.lead_value.value.value = leads.lead_value,
            this.follow_up_date.value.value = leads.follow_up_date,
            this.next_follow_up_date.value.value = leads.next_follow_up_date,
            this.requirement_type.value.value = leads.requirement_type,
            // this.lead_interest_id.value.value = leads.lead_interest_id,
            this.status.value.value = leads.status===1? 1: 0,
            // this.lead_action_id.value.value = leads.lead_action_id,
            this.lead_status_id.value.value = leads.lead_status_id,
            this.requirement_details.value.value = leads.requirement_details,
            this.synopsis_details.value.value = leads.synopsis_details
            this.buttonText = 'Update'
        } else {
            this.$store.commit("setEditingSalesLeads", null);
            this.isEntryMode = true;
            this.resetForm();
            this.lead_status_id.value.value = 1;
        }
    }  
}

</script>


